import * as authAction from '@/store/modules/auth/action-types'
import * as administrationAction from '@/store/modules/administration/action-types'
import * as catalogueAction from '@/store/modules/catalogue/action-types'
import * as uiAction from '@/store/modules/ui/action-types'

export default {  
  ...authAction,
  ...administrationAction,
  ...catalogueAction,
  ...uiAction
}